import styled, { css } from 'styled-components'
import { themeMedia } from '../../../styles/theme'

export const StyledSimpleModalWrapper = styled.div`
  height: 100%;
  padding: 100px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;

  ${({ noPadding }) =>
    noPadding &&
    css`
      padding: 0;
    `}

  img {
    height: 105px;
    margin-bottom: 10px;
  }

  button {
    margin-top: auto;
  }

  ${themeMedia.maxTablet`
    padding: 10vh 24px 50px;
    
    button {
      width: 100%;
    }

    img {
      margin-bottom: 1rem;
    }
  `}
`

export const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  max-width: 550px;
  align-items: center;
  justify-content: center;
  width: 100%;

  > * {
    text-align: center;
  }

  > h2:first-of-type {
  ${({ alwaysShowTitle }) =>
    !alwaysShowTitle &&
    css`
      display: none;

      ${themeMedia.tablet`
        display: block;
      `}
    `}
}
`
